import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function MenuIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M2 4H22V6H2V4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M2 11H22V13H2V11Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M22 18H2V20H22V18Z",
    fill: "currentColor"
  }));
}